/**
 * 告警
 */
const event = {
  setEventNotifyLevelRedefines: "/api/setEventNotifyLevelRedefines", //设置告警通知等级重命名
  getEventNotifyLevelRedefines: "/api/getEventNotifyLevelRedefines", //查询告警通知等级重命名
  getPersonalEventNotifyLevelRedefines:
    "/api/getPersonalEventNotifyLevelRedefines", //查询告警通知等级重命名
  addEventType: "/api/addEventType", //增加告警类型
  modifyEventType: "/api/modifyEventType", //修改告警类型
  deleteEventType: "/api/deleteEventType", //删除告警类型
  getEventTypes: "/api/getEventTypes", //查询告警类型
  addEventDetectRegulationTemplate: "/api/addEventDetectRegulationTemplate", //增加告警探测规则模板
  modifyEventDetectRegulationTemplate:
    "/api/modifyEventDetectRegulationTemplate", //修改告警探测规则模板
  deleteEventDetectRegulationTemplate:
    "/api/deleteEventDetectRegulationTemplate", //删除告警探测规则模板
  getEventDetectRegulationTemplates: "/api/getEventDetectRegulationTemplates", //查询告告警探测规则模板
  addEventDetectRegulationTemplateItem:
    "/api/addEventDetectRegulationTemplateItem", //增加告警探测规则模板项
  modifyEventDetectRegulationTemplateItem:
    "/api/modifyEventDetectRegulationTemplateItem", //修改告警探测规则模板项
  deleteEventDetectRegulationTemplateItem:
    "/api/deleteEventDetectRegulationTemplateItem", //删除告警探测规则模板项
  getEventDetectRegulationTemplateItems:
    "/api/getEventDetectRegulationTemplateItems", //查询告告警探测规则模板项
  resetEventDetectRegulationsViaTemplate:
    "/api/resetEventDetectRegulationsViaTemplate", //通过模板重置告警探测规则
  addEventDetectRegulation: "/api/addEventDetectRegulation", //增加告警探测规则
  modifyEventDetectRegulation: "/api/modifyEventDetectRegulation", //修改告警探测规则
  deleteEventDetectRegulation: "/api/deleteEventDetectRegulation", //删除告警探测规则
  getEventDetectRegulations: "/api/getEventDetectRegulations", //查询告警探测规则
  getEventDetectRegulations2: "/api/getEventDetectRegulations2", //查询告警探测规则
  addEventNotifyRegulation: "/api/addEventNotifyRegulation", //增加告警通知规则
  addEventNotifyRegulation2: "/api/addEventNotifyRegulation2", //增加告警通知规则
  modifyEventNotifyRegulation: "/api/modifyEventNotifyRegulation", //修改告警通知规则
  deleteEventNotifyRegulation: "/api/deleteEventNotifyRegulation", //删除告警通知规则
  getEventNotifyRegulations: "/api/getEventNotifyRegulations", //查询告警通知规则
  getEventRecord: "/api/getEventRecord", //查询告警/事件记录
  getCountOfEventRecord: "/api/getCountOfEventRecord", //查询告警/事件记录
  handleEvent: "/api/handleEvent", //处理告警/事件
  getEventHandlingResult: "/api/getEventHandlingResult", //查询告警处理表
  confirmEvent: "/api/confirmEvent", //确认告警/事件
  getEventConfirmingResult: "/api/getEventConfirmingResult", //查询告警处理表
  getOverviewThatCountOfEventHandling:
    "/api/getOverviewThatCountOfEventHandling", //查询告警计数概览
  getRankingThatCountOfEvent: "/api/getRankingThatCountOfEvent", //获取告警数量排行
  getRankingThatCountOfEvent2: "/api/getRankingThatCountOfEvent2", //获取告警数量排行

  modifyEventDetectRegulationEnable: "/api/modifyEventDetectRegulationEnable",
  modifyEventNotifyRegulationEnable: "/api/modifyEventNotifyRegulationEnable",

  addEventDetectRegulationForProperty:
    "/api/addEventDetectRegulationForProperty", //物业增加告警探测规则
  modifyEventDetectRegulationForProperty:
    "/api/modifyEventDetectRegulationForProperty", //物业修改告警探测规则
  deleteEventDetectRegulationForProperty:
    "/api/deleteEventDetectRegulationForProperty", //物业删除告警探测规则
  getEventDetectRegulationsForProperty:
    "/api/getEventDetectRegulationsForProperty", //物业查询告警探测规则
  getEventDetectRegulationsForProperty2:
    "/api/getEventDetectRegulationsForProperty2", //物业查询告警探测规则
  addEventNotifyRegulationForProperty:
    "/api/addEventNotifyRegulationForProperty", //物业增加告警通知规则
  addEventNotifyRegulationForProperty2:
    "/api/addEventNotifyRegulationForProperty2", //物业增加告警通知规则
  modifyEventNotifyRegulationForProperty:
    "/api/modifyEventNotifyRegulationForProperty", //物业修改告警通知规则
  deleteEventNotifyRegulationForProperty:
    "/api/deleteEventNotifyRegulationForProperty", //物业删除告警通知规则
  getEventNotifyRegulationsForProperty:
    "/api/getEventNotifyRegulationsForProperty", //物业查询告警通知规则
  getEventRecordForProperty: "/api/getEventRecordForProperty", //物业查询告警/事件记录
  getCountOfEventRecordForProperty: "/api/getCountOfEventRecordForProperty", //物业查询告警/事件记录
  handleEventForProperty: "/api/handleEventForProperty", //物业处理告警/事件
  getEventHandlingResultForProperty: "/api/getEventHandlingResultForProperty", //物业查询告警处理表
  confirmEventForProperty: "/api/confirmEventForProperty", //物业确认告警/事件
  getEventConfirmingResultForProperty:
    "/api/getEventConfirmingResultForProperty", //物业查询告警处理表
  getOverviewThatCountOfEventHandlingForProperty:
    "/api/getOverviewThatCountOfEventHandlingForProperty", //物业查询告警计数概览
  getRankingThatCountOfEventForProperty:
    "/api/getRankingThatCountOfEventForProperty", //物业获取告警数量排行
  getRankingThatCountOfEventForProperty2:
    "/api/getRankingThatCountOfEventForProperty2", //物业获取告警数量排行
  addEventDetectRegulationForCompanyLessee:
    "/api/addEventDetectRegulationForCompanyLessee", //公司租户增加告警探测规则
  modifyEventDetectRegulationForCompanyLessee:
    "/api/modifyEventDetectRegulationForCompanyLessee", //公司租户修改告警探测规则
  deleteEventDetectRegulationForCompanyLessee:
    "/api/deleteEventDetectRegulationForCompanyLessee", //公司租户删除告警探测规则
  getEventDetectRegulationsForCompanyLessee:
    "/api/getEventDetectRegulationsForCompanyLessee", //公司租户查询告警探测规则
  getEventDetectRegulationsForCompanyLessee2:
    "/api/getEventDetectRegulationsForCompanyLessee2", //公司租户查询告警探测规则
  addEventNotifyRegulationForCompanyLessee:
    "/api/addEventNotifyRegulationForCompanyLessee", //公司租户增加告警通知规则
  addEventNotifyRegulationForCompanyLessee2:
    "/api/addEventNotifyRegulationForCompanyLessee2", //公司租户增加告警通知规则
  modifyEventNotifyRegulationForCompanyLessee:
    "/api/modifyEventNotifyRegulationForCompanyLessee", //公司租户修改告警通知规则
  deleteEventNotifyRegulationForCompanyLessee:
    "/api/deleteEventNotifyRegulationForCompanyLessee", //公司租户删除告警通知规则
  getEventNotifyRegulationsForCompanyLessee:
    "/api/getEventNotifyRegulationsForCompanyLessee", //公司租户查询告警通知规则
  getEventRecordForCompanyLessee: "/api/getEventRecordForCompanyLessee", //公司租户查询告警/事件记录
  getCountOfEventRecordForCompanyLessee:
    "/api/getCountOfEventRecordForCompanyLessee", //公司租户查询告警/事件记录
  handleEventForCompanyLessee: "/api/handleEventForCompanyLessee", //公司租户处理告警/事件
  getEventHandlingResultForCompanyLessee:
    "/api/getEventHandlingResultForCompanyLessee", //公司租户查询告警处理表
  confirmEventForCompanyLessee: "/api/confirmEventForCompanyLessee", //公司租户确认告警/事件
  getEventConfirmingResultForCompanyLessee:
    "/api/getEventConfirmingResultForCompanyLessee", //公司租户查询告警处理表
  getOverviewThatCountOfEventHandlingForCompanyLessee:
    "/api/getOverviewThatCountOfEventHandlingForCompanyLessee", //公司租户查询告警计数概览
  getRankingThatCountOfEventForCompanyLessee:
    "/api/getRankingThatCountOfEventForCompanyLessee", //公司租户获取告警数量排行
  getRankingThatCountOfEventForCompanyLessee2:
    "/api/getRankingThatCountOfEventForCompanyLessee2", //公司租户获取告警数量排行
  addEventDetectRegulationForPersonalLessee:
    "/api/addEventDetectRegulationForPersonalLessee", //个人租户增加告警探测规则
  modifyEventDetectRegulationForPersonalLessee:
    "/api/modifyEventDetectRegulationForPersonalLessee", //个人租户修改告警探测规则
  deleteEventDetectRegulationForPersonalLessee:
    "/api/deleteEventDetectRegulationForPersonalLessee", //个人租户删除告警探测规则
  getEventDetectRegulationsForPersonalLessee:
    "/api/getEventDetectRegulationsForPersonalLessee", //个人租户查询告警探测规则
  getEventDetectRegulationsForPersonalLessee2:
    "/api/getEventDetectRegulationsForPersonalLessee2", //个人租户查询告警探测规则
  addEventNotifyRegulationForPersonalLessee:
    "/api/addEventNotifyRegulationForPersonalLessee", //个人租户增加告警通知规则
  addEventNotifyRegulationForPersonalLessee2:
    "/api/addEventNotifyRegulationForPersonalLessee2", //个人租户增加告警通知规则
  modifyEventNotifyRegulationForPersonalLessee:
    "/api/modifyEventNotifyRegulationForPersonalLessee", //个人租户修改告警通知规则
  deleteEventNotifyRegulationForPersonalLessee:
    "/api/deleteEventNotifyRegulationForPersonalLessee", //个人租户删除告警通知规则
  getEventNotifyRegulationsForPersonalLessee:
    "/api/getEventNotifyRegulationsForPersonalLessee", //个人租户查询告警通知规则
  getEventRecordForPersonalLessee: "/api/getEventRecordForPersonalLessee", //个人租户查询告警/事件记录
  getCountOfEventRecordForPersonalLessee:
    "/api/getCountOfEventRecordForPersonalLessee", //个人租户查询告警/事件记录
  handleEventForPersonalLessee: "/api/handleEventForPersonalLessee", //个人租户处理告警/事件
  getEventHandlingResultForPersonalLessee:
    "/api/getEventHandlingResultForPersonalLessee", //个人租户查询告警处理表
  confirmEventForPersonalLessee: "/api/confirmEventForPersonalLessee", //个人租户确认告警/事件
  getEventConfirmingResultForPersonalLessee:
    "/api/getEventConfirmingResultForPersonalLessee", //个人租户查询告警处理表
  getOverviewThatCountOfEventHandlingForPersonalLessee:
    "/api/getOverviewThatCountOfEventHandlingForPersonalLessee", //个人租户查询告警计数概览
  getRankingThatCountOfEventForPersonalLessee:
    "/api/getRankingThatCountOfEventForPersonalLessee", //个人租户获取告警数量排行
  getRankingThatCountOfEventForPersonalLessee2:
    "/api/getRankingThatCountOfEventForPersonalLessee2", //个人租户获取告警数量排行

  getCountOfEventStatusGroupByLevel: "/api/getCountOfEventStatusGroupByLevel", //获取告警处理/确认状态分等级计数
  getCountOfEventGroupByType: "/api/getCountOfEventGroupByType", //获取告警处理/确认状态分类计数
  getCountOfEventGroupByCode: "/api/getCountOfEventGroupByCode", //获取告警处理/确认状态按告警编码计数

  getCountOfEventStatusGroupByLevelForProperty:
    "/api/getCountOfEventStatusGroupByLevelForProperty", //物业获取告警处理/确认状态分等级计数
  getCountOfEventGroupByTypeForProperty:
    "/api/getCountOfEventGroupByTypeForProperty", //物业获取告警处理/确认状态分类计数
  getCountOfEventStatusGroupByLevelForCompanyLessee:
    "/api/getCountOfEventStatusGroupByLevelForCompanyLessee", //公司租户获取告警处理/确认状态分等级计数
  getCountOfEventGroupByTypeForCompanyLessee:
    "/api/getCountOfEventGroupByTypeForCompanyLessee", //公司租户获取告警处理/确认状态分类计数
  getCountOfEventStatusGroupByLevelForPersonalLessee:
    "/api/getCountOfEventStatusGroupByLevelForPersonalLessee", //获取告警处理/确认状态分等级计数
  getCountOfEventGroupByTypeForPersonalLessee:
    "/api/getCountOfEventGroupByTypeForPersonalLessee", //获取告警处理/确认状态分类计数
  setPersonalEventNotifyLevelRedefines:
    "/api/setPersonalEventNotifyLevelRedefines", //个人设置告警通知等级重命名
  getPersonalEventNotifyLevelRedefines:
    "/api/getPersonalEventNotifyLevelRedefines", //个人查询告警通知等级重命名
  getCountOfEventGroupByCode: "/api/getCountOfEventGroupByCode", //获取告警处理/确认状态按告警编码计数
  getCountOfEventGroupByCodeForProperty:
    "/api/getCountOfEventGroupByCodeForProperty", //获取告警处理/确认状态按告警编码计数
  getCountOfEventGroupByCodeForCompanyLessee:
    "/api/getCountOfEventGroupByCodeForProperty", //获取告警处理/确认状态按告警编码计数
  getCountOfEventGroupByCodeForPersonalLessee:
    "/api/getCountOfEventGroupByCodeForPersonalLessee",
};

export default event;
